import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'platform-studio',
});

export const entityDetailRouteRef = createSubRouteRef({
  id: 'platform-studio/entity-detail',
  parent: rootRouteRef,
  path: '/:entityType/:name',
});
